/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
//material

import Button from "material/ctas/button/button";
import Link from "material/ctas/link/link";
import styles from 'material/imageupload/components/controls/controls_styles';
import injectSheet from "react-jss";
class Controls extends Component {
    render() {
        let { zoom, zoomChange, submit, cancel, onNewSelect } = this.props;
        return (
            <div className={`controls ${this.props.classes.controls}`} >
                {!this.props.isGif && <input type="range" min="0.25" max="5" step=".25" value={zoom} className={"slider"} onChange={e=>zoomChange(e.target.value)}  /> }
                <div className={`actions`} >
                    <Button type={'action'} color={'secondary'} name={`submit`} action={submit} text={'Submit'} />
                    <Button type={'action'} color={'attention'} name={`cancel`} action={cancel} text={'Cancel'} />
                    <div className={`newImageButtonContainer`} >
                        <input className={`newImageInput`} type={'file'} onChange={onNewSelect} />
                        <Link name={`newImageButton`} color={'primary'} text={'New Image'} />
                    </div>
                </div>
            </div>
        );
    };
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Controls);
